import types from "resources/types";
import { createResourceDetailQuery } from "queries";

export const onboardingRequirementsQuery = (config = {}) =>
  createResourceDetailQuery(types.ONBOARDING_REQUIREMENTS, {
    url: "/api/v2/onboarding_requirements/",
    ...config,
  });
